import React from "react";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";


const Funding = () => {
  return (
    <Container>
    <h2 className="display-6 fw-bold my-4">Funding of APCs and BPCs
    </h2>
    <hr />

    <p className="joab-common-para my-4">Many funding agencies and institutions explicitly allow the use of research grants for the payment of APCs for publishing open access articles and books.</p>

    <h4 className="fw-bold mb-3">Discounts on APCs</h4>
    <p className="joab-common-para mb-4">Green Publication provides discounts for authors under the following conditions:</p>

    <h4 className="fw-bold mb-4">APC Waive (Full/partial)</h4>
    <h4 className="fw-bold mb-3">Limited financial funds</h4>

    <p className="joab-common-para mb-4">For scientists with limited financial funds (solely reserved for payment of publication fees), a (partial) waive of APC is possible when he/she can prove this limitation.</p>
  
 

    <h4 className="fw-bold">Low/middle income countries</h4>
    <p className="joab-common-para mb-4">Reduction/waiver of the Article Processing Charge is possible.<br/> We use data from the gross national income (GNI) per capita for the previous year defined by the World Bank.</p>


    <p className="joab-common-para mb-4">Income classifications by GNI per capita are for the year 2021 as follows:</p>
    <ul className="mb-3 joab-common-para">
            <li>
              <span className="fw-bold">Lower-middle income : </span> $1,046 to $4,095
            </li>
            <li>
              <span className="fw-bold">Upper middle income : </span> $4,096 to $12,695
            </li>
            <li>
              <span className="fw-bold">High income : </span> $12,696 or more.
            </li>
          </ul>

    <p className="joab-common-para mb-4">Waivers may be granted at the Publisher’s discretion and should be discussed with the editorial office when submitting the article. The editorial decision-making is decoupled from the authors’ ability to pay the Processing Charges, however, authors should consider in advance whether they have sufficient funds to cover the full APC/BPC.
  </p>


    <p className="joab-common-para mb-4">To apply for APC Waive the APC Waiver Application Form needs to be completed and mailed to the Editorial Office 
    <a href="mailto:editor@journalofappliedbioanalysis.com">(editor@journalofappliedbioanalysis.com)</a>
    

    </p>
    <div style={{height: "10000px"}}>
      jsdjcd
    </div>

    


  </Container>
  );
};

export default Funding;
